import React from 'react';
import { Field, reduxForm, formPropTypes } from 'redux-form';
import PropTypes from 'prop-types';

import {
  FormGroup,
  Row,
  Col,
  ControlLabel,
  Button,
  ButtonToolbar,
} from 'react-bootstrap';

import PerDiemTicketInputEnhanced from '../../fields/TicketInput/containers/PerDiemTicketInputEnhanced';
import { DateField } from '../../fields/index';
import UserPicker from '../../fields/UserPicker/containers/PerDiemUserPickerEnhanced';


const FORM_NAME = 'perDiemRequestForm';

const propTypes = {
  initialValues: PropTypes.object,
  ...formPropTypes,
};

const validate = (values) => {
  const errors = [];

  if (values.date && values.date.length < 10) {
    errors.date = 'Invalid Date';
  }
  if (!values.date) {
    errors.date = 'Select a Date';
  }

  if (!values.ticket_number) {
    errors.ticket_number = 'Select a Ticket Number';
  }
  if (!values.employees || !values.employees.length) {
    errors.employees = 'Select employees';
  }

  return errors;
};

/* eslint-disable */
const createRenderer = (render) => ({ input, meta, label, ...rest }) => {
  return (
    <div
      className={[
        meta.error && meta.touched ? 'form-error' : '',
        meta.active ? 'form-active' : '',
      ].join(' ')}
    >
      <ControlLabel>
        {label}
      </ControlLabel>

      {render(input, label, rest)}

      {meta.error && meta.touched &&
        <span>{meta.error}</span>
      }
    </div>
  );
};
/* eslint-enable */

const RenderTicket = createRenderer((input) => {
  return (
    <PerDiemTicketInputEnhanced allowTicketCreation={false} {...input} />
  );
});

const RenderUserPicker = createRenderer((input) => {
  return (
    <UserPicker {...input} />
  );
});

const PerDiemRequestFormForDate = (props) => {
  const {
    handleSubmit,
    submitting,
    invalid,
    formSubmit,
  } = props;

  return (
    <form onSubmit={handleSubmit(formSubmit)}>
      <Row>
        <Col xs={12} sm={6} md={4}>
          <FormGroup>
            <DateField
              name="date"
              label="Date"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6} md={4}>
          <FormGroup>
            <Field
              name="ticket_number"
              type="input"
              label="Ticket Number"
              format={null}
              component={RenderTicket}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={6} md={4}>
          <FormGroup>
            <Field
              name="employees"
              label="Employees"
              format={null}
              type="select"
              component={RenderUserPicker}
            />
          </FormGroup>
        </Col>
      </Row>
      {/* NOTE: one button is styled for mobile, other for desktop */}
      <Row>
        <Col className="visible-xs" xs={12}>
          <Button
            style={{ width: '100%' }}
            bsStyle="primary"
            type="submit"
            disabled={(submitting || invalid)}
          >
            Submit
          </Button>
        </Col>
        <Col className="hidden-xs" sm={6} md={4}>
          <ButtonToolbar className="pull-right">
            <Button
              bsStyle="primary"
              type="submit"
              disabled={(submitting || invalid)}
            >
              Submit
            </Button>
          </ButtonToolbar>
        </Col>
      </Row>
    </form>
  );
};

PerDiemRequestFormForDate.propTypes = propTypes;
PerDiemRequestFormForDate.defaultProps = {
  initialValues: {},
};

const withForm = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate,
});

export default withForm(PerDiemRequestFormForDate);
